import React, { useEffect, useState } from 'react';
import { Button, Grid, Container, Select, MenuItem, FormControl } from '@mui/material';
// import { enviarmails } from '../../../../services/services';
import moment from 'moment';
import { getData } from '../../services/library';
import ConfirmDialog from '../Dialogs/ConfirmDialog';
import CheckIcon from "@material-ui/icons/Check";
import Notify from '../Notify';
import { formatoImporte } from './formatoImporte';

export default function Openpdf(props) {
    const [lista, setlista] = useState();
    const [empresas, setEmpresas] = useState();
    const [datosOrden, setdatosOrden] = useState([{}])
    const [subtotal, setSubtotal] = useState(0);
    const [nivel, setNivel] = useState(null)
    const fecha = (moment(new Date()).format("DD-MM-YYYY"));
    const tipoMonedaMapping = {
        82: "u$s",
        83: "$",
        84: "€",
    };
    const tipoMoneda = datosOrden[0] && datosOrden[0].tipo_moneda !== undefined ? datosOrden[0].tipo_moneda : props.datos.tipo_moneda;
    const iconoMoneda = tipoMonedaMapping[tipoMoneda] || "Error";
    const estadoLista = props.datos?.id_estado;
    const estadoDetalle = datosOrden?.[0]?.id_estado;
    const etiquetaEstado = String(
        props.datos?.valor_estado ?? datosOrden?.[0]?.estado_oc ?? ""
    ).trim().toLowerCase();
    const ordenAutorizada =
        Number(estadoLista) === 81 ||
        Number(estadoDetalle) === 81 ||
        etiquetaEstado === "autorizada";
    const ordenPendienteAprobacion =
        typeof props.autorizarOrden === "function" &&
        !ordenAutorizada &&
        Number(estadoLista ?? estadoDetalle) === 89;
    const [aprobar, setAprobar] = useState(false);
    const iconCheck = <CheckIcon sx={{ fontSize: 40 }} />;
    const [notificacion, setNotificacion] = useState({
        open: false,
        mensaje: "",
        severity: "",
        color: "",
    });
    const [selectedEmpresa, setSelectedEmpresa] = useState(null);
    /* tengo que obtener la lista de materiales de la orden de compra 
    tengo que pasar  como proppiedad el uuid de la orden de compra 
    si viene de "requerimientos, va a tener asique no problem"
    en todo caso si viene desde ordenes tambien va a tener uuid */

    const getListaMateriales = () => {
        getData('/lista_materiales/ordencompra/' + props.uuid, setlista)
    };

    /*Si viene desde un requerimiento necesito obtener los datos de la orden de
    compra desde el requerimiento, si no viene como props.datos*/
    const getDatosOrden = () => {
        getData("/ordencompra/requerimiento/" + props.uuid, setdatosOrden)
    };

    useEffect(() => {
        getData('/empresas', setEmpresas)
        getDatosOrden()
        getListaMateriales()
        getData(`/autorizantes_compras/username/${localStorage.getItem('user')}`, setNivel)
    }, [props.uuidreq]);

    useEffect(() => {
        lista && recorrerSubtotales()
    }, [lista]);

    const recorrerSubtotales = () => {
        let sub = 0
        lista && lista.forEach(element => {
            sub = sub + element.subtotal
        });
        setSubtotal(sub)
    };

    const Print = () => {
        var printContent = document.getElementById('imprimime');
        var WinPrint = window.open();
        WinPrint.document.write(printContent.innerHTML);
        WinPrint.document.close();
        var images = WinPrint.document.getElementsByTagName('img');
        var loadedImages = 0;
        for (var i = 0; i < images.length; i++) {
            images[i].onload = function () {
                loadedImages++;
                if (loadedImages === images.length) {
                    WinPrint.focus();
                    WinPrint.print();
                    WinPrint.close();
                }
            };
        }
        WinPrint.document.close();
    };

    const handleEmpresaChange = (event) => {
        const selectedLogo = event.target.value;

        const selectedEmpresa = empresas.find(empresa => empresa.logo === selectedLogo);
        setSelectedEmpresa(selectedEmpresa);
    };

    /*Con el tema del logo lo mismo puede ser de la orden de compra
    o de la empresa que quiera facturar */

    return (
        <>

            {/* <select onChange={handleEmpresaChange}>
                <option value="">Seleccione una empresa</option>
                {empresas && empresas.map((empresa, index) => (
                    <option key={index} value={empresa.logo}>
                        {empresa.empresa}
                    </option>
                ))}
            </select> */}

            <div id="imprimime">
                <table
                    border="1"
                    position="absolute"
                    width="1000px"
                    margin="auto"
                    style={{
                        marginLeft: "auto",
                        marginRight: "auto",

                        borderCollapse: "collapse",
                        marginBottom: "20px",
                    }}
                >
                    <table
                        border="1"
                        style={{
                            borderCollapse: "collapse",
                            width: "100%",
                            height: "90px",
                        }}
                    >
                        <tr>
                            <th>

                                {props.datos && (
                                    <>
                                        <img src={props.datos.logo} alt="Logo de la empresa" height={90} />
                                        <p>{props.datos.empresa}
                                            <br />{props.datos.cuit}</p>
                                    </>)}
                            </th>
                            <td style={{ fontSize: 22, textAlign: "center" }}>
                                <b>Orden de compra {datosOrden && datosOrden[0] && datosOrden[0].idordencompra !== undefined ? datosOrden[0].idordencompra : props.datos.idordencompra}</b>
                                <br />
                                <p style={{ fontSize: 14, textAlign: "center" }}> Fecha:  {fecha} </p></td>
                        </tr>
                    </table>
                    <table
                        border="1"
                        style={{
                            borderCollapse: "collapse",
                            width: "100%",
                            height: "55px",
                        }}
                    >
                        <tr style={{ fontSize: 14 }}>
                            <td style={{ textAlign: "left" }}>
                                <b>  Señores:  </b>{datosOrden?.[0]?.razon_social || props.datos.razon_social}  {" "}
                                {datosOrden?.[0]?.direccion || props.datos.direccion} {" "}
                                {datosOrden?.[0]?.localidad || props.datos.localidad} {" "}
                                {datosOrden?.[0]?.provincia || props.datos.provincia} {" "}
                            </td>
                        </tr>
                    </table>

                    <table
                        border="1"
                        style={{
                            borderCollapse: "collapse",
                            width: "100%",
                            height: "55px",
                        }}
                    >
                        <tr style={{ fontSize: 14 }}>
                            <td style={{ textAlign: "left" }}>
                                Agradeceremos entregar los elementos que detallamos a continuación y con las siguientes condiciones:
                                <br />
                                <b>{datosOrden && datosOrden[0] !== undefined ? datosOrden[0].condicion_venta : props.datos.condicion}</b>
                            </td>
                            <td style={{ textAlign: "center" }}>
                                Sucursal:
                                <br />
                                <b>{props.datos.sucursal ?? props.datos.nombre_sucursal}</b>
                            </td>
                            <td style={{ textAlign: "center" }}>
                                Fecha de entrega:
                                <br />
                                <b>{props.datos.fecha_entrega ? moment(props.datos.fecha_entrega).format("DD/MM/YYYY") : "No hay registro"}</b>
                            </td>
                            <td style={{ textAlign: "center" }}>
                                IVA:
                                <br />
                                <b>{datosOrden &&
                                    datosOrden[0] !== undefined
                                    && datosOrden[0].iva_incluido === 1 ?
                                    "Incluido" :
                                    (props.datos &&
                                        props.datos &&
                                        props.datos.iva_incluido === 1 ? "Incluido" : "No incluido")
                                }
                                </b>
                            </td>
                        </tr>
                    </table>
                    <table
                        border="1"
                        style={{
                            borderCollapse: "collapse",
                            width: "100%",
                            height: "55px",
                        }}
                    >
                        <tr style={{ fontSize: 14 }}>
                            <td style={{ textAlign: "center" }}>
                                <b>Observaciones  </b>
                                <br />
                                {props.datos.observaciones}
                            </td>
                        </tr>
                    </table>
                    <table
                        border="1"
                        style={{
                            borderCollapse: "collapse",
                            width: "100%",
                            height: "55px",
                        }}
                    >
                        <tr>
                            <th>Cantidad</th>
                            <th>Articulo</th>
                            <th>Precio Unitario</th>
                            <th>Bonificación por item</th>
                            <th>Neto</th>
                        </tr>
                        {lista && lista.map((row) => (
                            <tr align="center" key={row.id}>
                                <td>{row.total_cantidad_actualizada}</td>
                                <td>{row.nombre ?? row.material }</td>
                                <td>{iconoMoneda}{formatoImporte(row.precio_unitario)}</td>
                                <td>{(row.bonificacion_pesos !== null ? "$" : (row.bonificacion_porcentaje !== null ? "%" : ""))
                                }{row.bonificacion_pesos !== null ? formatoImporte(row.bonificacion_pesos) : (row.bonificacion_porcentaje !== null ? row.bonificacion_porcentaje : "-")}</td>
                                <td>{iconoMoneda}{formatoImporte(row.subtotal)}</td>
                            </tr>
                        ))}
                    </table>
                    <table
                        border="1"
                        style={{
                            borderCollapse: "collapse",
                            width: "100%",
                            height: "55px",
                        }}
                    >
                        <tr align="center">
                            <th>SUBTOTAL</th>
                            <td>
                                {iconoMoneda}{formatoImporte(subtotal)}
                            </td>
                        </tr>
                        <tr align="center">
                            <th>BONIFICACIÓN AL TOTAL</th>
                            <td>{lista && datosOrden && datosOrden[0] && datosOrden[0].bonificacion_pesos ? iconoMoneda + formatoImporte(datosOrden[0].bonificacion_pesos) : props.datos.bonificacion_porcentaje}  </td>
                        </tr>
                        <tr align="center">
                            <th >TOTAL</th>
                            <td>
                                {iconoMoneda !== undefined ? `${iconoMoneda} ${formatoImporte(datosOrden && datosOrden[0] && datosOrden[0].total !== undefined ? datosOrden[0].total : props.datos.total)}` : "Error: Tipo de moneda no reconocido"}
                            </td>
                        </tr>
                    </table>
                </table>
            </div>
            {
                !props.readOnly && (
                    <div>
                    <Container fixed>
                        <Grid mt={2}
                            mb={5}
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignitemns="center"
                        >
                            <Button
                                variant="contained"
                                type="button"
                                color="error"
                                onClick={() => {
                                    props.open(false)
                                    props.tabla(true)
                                    props.tab && props.tab(true)
                                }}>Volver</Button>
                            {nivel?.[0]?.nivel === 4 && ordenPendienteAprobacion ?
                                <Button
                                    variant="contained"
                                    type="button"
                                    color="warning"
                                    onClick={() => setAprobar(true)} >Aprobar</Button>
                                : null}
                            <Button
                                variant="contained"
                                type="button"
                                color="success"
                                onClick={Print} >Imprimir</Button>
    
                        </Grid>
                    </Container>
                    {aprobar ?
                        <ConfirmDialog
                            title={"Aprobar orden de compra"}
                            subtitle={"¿Desea aprobar la orden de compra ?"}
                            open={aprobar}
                            setOpen={setAprobar}
                            notify={notificacion}
                            setNotify={setNotificacion}
                            btnText={"Aprobar"}
                            guardar={props.autorizarOrden}
                            color={"#2ECC71"}
                            icon={iconCheck}
                        />
                        : null}
                    {notificacion && notificacion.open ? (
                        <Notify
                            mensaje={notificacion.mensaje}
                            open={notificacion.open}
                            color={notificacion.color}
                            handleClose={() => {
                                props.open(false)
                                props.tabla(true)
                                props.tab && props.tab(true)
                            }}
                            severity={notificacion.severity}
                        />
                    ) : null}
                </div>
                )
            }
        </>
    )
}
